import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import { PageHeader, Card, Badge, EmptyState, formatDate } from '../components/UI';

export default function Stats() {
  const [tab, setTab] = useState('classes');

  return (
    <>
      <PageHeader
        eyebrow="Análisis"
        title="Estadísticas"
        subtitle="Métricas detalladas de uso"
      />

      <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
        <Tab active={tab === 'classes'} onClick={() => setTab('classes')}>Por clase</Tab>
        <Tab active={tab === 'patients'} onClick={() => setTab('patients')}>Por paciente</Tab>
      </div>

      {tab === 'classes' ? <ClassStats /> : <PatientStats />}
    </>
  );
}

function ClassStats() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.statsClasses().then(setList).catch(e => alert(e.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <EmptyState>Cargando…</EmptyState>;
  if (!list.length) return <EmptyState>Sin datos todavía.</EmptyState>;

  const maxPlays = Math.max(...list.map(c => c.total_plays), 1);

  return (
    <Card padding={0}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid var(--border)' }}>
            <Th>Clase</Th>
            <Th>Audiciones</Th>
            <Th>Oyentes</Th>
            <Th>% Promedio</Th>
            <Th>Completadas</Th>
            <Th>Favoritos</Th>
            <Th></Th>
          </tr>
        </thead>
        <tbody>
          {list.map(c => (
            <tr key={c.id} style={{ borderBottom: '1px solid var(--border)' }}>
              <Td>
                <div style={{ fontSize: 9, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--earth)' }}>
                  {c.code}
                </div>
                <div>{c.title}</div>
                <div style={{ fontSize: 11, color: 'var(--stone)' }}>{formatDate(c.class_date)}</div>
              </Td>
              <Td><strong>{c.total_plays}</strong></Td>
              <Td>{c.unique_listeners}</Td>
              <Td>{c.avg_pct ? `${Math.round(c.avg_pct)}%` : '—'}</Td>
              <Td>{c.completed_count}</Td>
              <Td>{c.favorite_count}</Td>
              <Td style={{ width: 120 }}>
                <Bar value={c.total_plays} max={maxPlays} />
              </Td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}

function PatientStats() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.statsPatients().then(setList).catch(e => alert(e.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <EmptyState>Cargando…</EmptyState>;
  if (!list.length) return <EmptyState>Sin datos todavía.</EmptyState>;

  return (
    <Card padding={0}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid var(--border)' }}>
            <Th>Paciente</Th>
            <Th>Audiciones totales</Th>
            <Th>Clases distintas</Th>
            <Th>Completadas</Th>
            <Th>Última actividad</Th>
          </tr>
        </thead>
        <tbody>
          {list.map(p => (
            <tr key={p.id} style={{ borderBottom: '1px solid var(--border)' }}>
              <Td>
                <div style={{ fontWeight: 400 }}>{p.name}</div>
                <div style={{ fontSize: 11, color: 'var(--ink-soft)' }}>{p.email}</div>
              </Td>
              <Td><strong>{p.total_plays}</strong></Td>
              <Td>{p.unique_classes}</Td>
              <Td>{p.completed_count}</Td>
              <Td muted>{p.last_played ? formatDate(p.last_played) : '—'}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}

function Tab({ active, children, onClick }) {
  return (
    <button onClick={onClick} style={{
      padding: '5px 14px',
      borderRadius: 20,
      border: '1px solid ' + (active ? 'var(--ink)' : 'var(--border)'),
      background: active ? 'var(--ink)' : 'transparent',
      color: active ? 'var(--sand)' : 'var(--ink-soft)',
      fontSize: 11, fontWeight: 300, letterSpacing: '0.1em',
      cursor: 'pointer',
    }}>{children}</button>
  );
}

function Bar({ value, max }) {
  const pct = (value / max) * 100;
  return (
    <div style={{ height: 4, background: 'var(--sand-2)', borderRadius: 2, overflow: 'hidden' }}>
      <div style={{ width: `${pct}%`, height: '100%', background: 'var(--earth)' }} />
    </div>
  );
}

const Th = ({ children }) => (
  <th style={{
    textAlign: 'left', padding: '12px 16px',
    fontSize: 9, fontWeight: 300, letterSpacing: '0.18em',
    textTransform: 'uppercase', color: 'var(--earth)',
  }}>{children}</th>
);

const Td = ({ children, muted, style = {} }) => (
  <td style={{
    padding: '12px 16px', fontSize: 13,
    color: muted ? 'var(--ink-soft)' : 'inherit',
    ...style,
  }}>{children}</td>
);
